module.exports = __webpack_public_path__ + "assets/missing-user-picture.32dc40f5.png";